<ng-container *ngIf="!env.ONBOARDING?.FORGOT_PASSWORD_NEW">
    <div class="progress-wrapper">
        <ridango-page-content-wrapper>
            <ridango-progress-v2 [steps]="steps" [activeStep]="step"></ridango-progress-v2>
        </ridango-page-content-wrapper>
    </div>

    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <ridango-page-content-wrapper *ngIf="allowReset">
                <div class="ticket" *ngIf="step === 1">
                    <div class="block__left-side-panel">
                        <rwidget-recover-password-side></rwidget-recover-password-side>
                    </div>

                    <div class="block__right-side-panel">
                        <rwidget-recover-password
                            [callback]="callback"
                            (onSubmitEmail)="submitEmail($event)"
                            (onCompleteStep)="handleComplete($event)"></rwidget-recover-password>
                    </div>
                </div>

                <div class="ticket" *ngIf="step === 2">
                    <rwidget-email-sent [email]="email"></rwidget-email-sent>
                </div>
            </ridango-page-content-wrapper>
        </div>
    </div>
</ng-container>

<gl-password-recover-page-v2 *ngIf="env.ONBOARDING?.FORGOT_PASSWORD_NEW"></gl-password-recover-page-v2>
